module.exports = __webpack_public_path__ + "./img/apps.98404627f3f925c8533e357ed9836bb9.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/apps.png
// module id = ./assets/images/apps.png
// module chunks = 0